<ms-scroll-adapter *ngIf="scrollEnabled; else tabTemplate" [msScrollSelectedInView]="activeEventid" [scrollSize]="scrollSize" [stretch]="stretch">
    <ng-template *ngTemplateOutlet="tabTemplate"></ng-template>
</ms-scroll-adapter>

<ng-template #tabTemplate>
    <ul class="tab-bar-container" *ngIf="events?.length">
        <li
            class="tab-bar-item"
            *ngFor="let tab of events; trackBy: trackTabsBy; let index = index"
            [class.active]="tab.active"
            [attr.data-menu-item-id]="tab.event.id">
            <a (click)="selected($event, tab, index)">
                <ms-showcase-scoreboard [event]="tab.event"></ms-showcase-scoreboard>
            </a>
        </li>
    </ul>
</ng-template>
